import { useFilters } from "core/features/filters/store";
import { AdvancedFiltersProps } from "../components/concentracao-colheita";

const useAdvancedFiltersProdutividade = () => {
  const { updateFiltroProdutividade, filters } = useFilters();
  const { filtroProdutividade } = filters;

  const filterSafraPeriodos = filtroProdutividade?.safraPeriodos;

  const applyFilters = (
    advancedFilters: AdvancedFiltersProps,
    handleCloseModal: () => void
  ) => {
    updateFiltroProdutividade(
      {
        safraPeriodos: advancedFilters.safraPeriodos,
      },
      true
    );
    handleCloseModal();
  };

  const clearFilters = (
    handleResetFiltersState: (advancedFilters: AdvancedFiltersProps) => void
  ) => {
    updateFiltroProdutividade(
      {
        safraPeriodos: [],
      },
      true
    );
    handleResetFiltersState({
      safraPeriodos: [],
    });
  };

  return {
    items: {
      filterSafraPeriodos,
    },
    onChange: applyFilters,
    clearFilters,
  };
};

export default useAdvancedFiltersProdutividade;
